<cerrix-loader [cerrixTab]="tab"></cerrix-loader>
<ng-template #manualPage></ng-template>
